import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { SpinnerComponent } from '../spinner/spinner.component';
import { ScoreChipLevel } from './score-chip-level.enum';
import { resolveScoreChipLevel } from './score-chip-levels';

@Component({
  selector: 'ct-lib-score-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, SpinnerComponent],
  template: `
    <div [class.small]="small()">
      <div
        class="score-chip d-flex align-items-center"
        [class]="designClass()"
        [class.show-chevron]="showChevronResult()"
        [class.refreshing]="refreshing()"
      >
        @if (loading() || refreshing()) {
          <ct-lib-spinner [color]="refreshing() ? 'white' : ''"></ct-lib-spinner>
        }
        @if (label()) {
          <span class="score-label d-flex align-items-center" [class]="designClass()">
            {{ label() }}
            @if (showChevronResult()) {
              <fa-icon [icon]="faChevronRight"></fa-icon>
            }
          </span>
        }
      </div>
    </div>
  `,
  styleUrl: './score-chip.component.scss',
})
export class ScoreChipComponent {
  readonly faChevronRight = faChevronRight;

  readonly loading = input(false);
  readonly refreshing = input(false);
  readonly score = input<number>();
  readonly label = input<string>();
  readonly small = input(false);
  readonly showChevron = input(true);

  readonly designClass = computed(() => {
    if (this.loading()) {
      return ScoreChipLevel.LOADING;
    }
    return resolveScoreChipLevel(this.score());
  });

  readonly showChevronResult = computed(
    () =>
      this.showChevron() &&
      !this.loading() &&
      this.designClass() !== ScoreChipLevel.INSUFFICIENT_DATA &&
      this.designClass() !== ScoreChipLevel.ERROR
  );
}
